// Author YuJiaBei
// Date 2021-07-18 10:45:03

class EmOpcUaNodeSubscriptionEouns {
constructor({
        id = null,
        eouniNodeId = '',
        eouniNamespaceIndex = '',
        eouniIdentifier = '',
        eouniText = '',
        eouniSamplingInterval = '',
        eouniQueueSize = '',
        eouniDiscardOldest = '',
        eouniEnable = '',
        remark = ''}
= {}) {
    this.id = id;
    this.eouniNodeId = eouniNodeId;
    this.eouniNamespaceIndex = eouniNamespaceIndex;
    this.eouniIdentifier = eouniIdentifier;
    this.eouniText = eouniText;
    this.eouniSamplingInterval = eouniSamplingInterval;
    this.eouniQueueSize = eouniQueueSize;
    this.eouniDiscardOldest = eouniDiscardOldest;
    this.eouniEnable = eouniEnable;
    this.remark = remark;
}
}

function newEntity() {
return new EmOpcUaNodeSubscriptionEouns();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniNodeId',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.grid.eouniNodeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniNamespaceIndex',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.grid.eouniNamespaceIndex',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniIdentifier',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.grid.eouniIdentifier',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniText',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.grid.eouniText',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniSamplingInterval',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.grid.eouniSamplingInterval',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniQueueSize',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.grid.eouniQueueSize',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniDiscardOldest',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.grid.eouniDiscardOldest',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'eouniEnable',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.grid.eouniEnable',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    eouniNodeIdFilter : "",
    eouniNamespaceIndexFilter : "",
    eouniIdentifierFilter : "",
    eouniSamplingIntervalFilter : "",
    eouniQueueSizeFilter : "",
    eouniDiscardOldestFilter : "",
    eouniEnableFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'eouniNodeIdFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.filter.eouniNodeId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniNamespaceIndexFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.filter.eouniNamespaceIndex',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniIdentifierFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.filter.eouniIdentifier',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniSamplingIntervalFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.filter.eouniSamplingInterval',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniQueueSizeFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.filter.eouniQueueSize',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniDiscardOldestFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.filter.eouniDiscardOldest',
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'eouniEnableFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.filter.eouniEnable',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'eouniNodeId',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.entity.eouniNodeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcUaNodeInfoEouni'
            ,correspondingField: 'nodeId'
            ,fieldsBindingByEntityModalSelected: '{"eouniNamespaceIndex":"eouniNodeidNamespaceIndex","eouniIdentifier":"eouniNodeidIdentifier","eouniText":"eouniDisplaynameText"}'
                }
        },
        {
        key: 'eouniNamespaceIndex',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.entity.eouniNamespaceIndex',
        sortable: true,
        disabled: true,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniIdentifier',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.entity.eouniIdentifier',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniText',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.entity.eouniText',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniSamplingInterval',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.entity.eouniSamplingInterval',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniQueueSize',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.entity.eouniQueueSize',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniDiscardOldest',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.entity.eouniDiscardOldest',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'eouniEnable',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.entity.eouniEnable',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcUaNodeSubscriptionEouns.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmOpcUaNodeSubscriptionEouns, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
